{
  "es": {
    "upload": {
      "labels": {
        "cancelUpload": "Cancelar subida",
        "cancelUploadConfirmation": "¿Estás seguro de que quieres cancelar esta subida?",
        "chooseCategory": "Haz clic para seleccionar primero una categoría",
        "defaultMessage": "Añade o arrastra archivos",
        "fallbackMessage": "Tu navegador no admite la subida de archivos arrastrando y soltando.",
        "fallbackText": "Usa el formulario alternativo de abajo para subir tus archivos, como en los viejos tiempos.",
        "fileTooBig": "El archivo es demasiado grande ({filesize} MB). Tamaño máximo: {maxFilesize} MB.",
        "invalidFileType": "No puedes subir archivos de este tipo.",
        "maxFilesExceeded": "No puedes subir más archivos.",
        "noExtension": "El archivo no tiene extensión",
        "rejectedFiles": "Se rechazaron los siguientes archivos:",
        "removeFile": "Eliminar archivo",
        "responseError": "El servidor respondió con el código {statusCode}.",
        "uploadConfirmation": "Subida confirmada",
        "uploadError": "Error al subir",
        "warningMaxFileSize": "Hasta {max_files_size} cada uno"
      }
    }
  }
}
